import React, { useEffect, useState, useRef } from "react";
import { getAxiosResponse } from "../../services/authApiRoutes/APImethods";
import APIUrls from "../../services/APIUrls";
import { useSelector, useDispatch } from "react-redux";
import { updateCampaignOrder } from "../../redux/reducers/CampaignCountDisplayOrder";
import { RotatingLines } from "react-loader-spinner";
import { useTranslation } from 'react-i18next';
import Constants from "../../Constants";
import { updateCampaignStatus } from "../../redux/reducers/CampaignStatusFilterSlice";

import $ from "jquery"
import Popover from "../project/Popover";
import { useNavigate } from "react-router-dom";

export default function CampaignStatusCountBlock() {
  const { t } = useTranslation();
  const navigate=useNavigate();
  const translate = t;
  const tilesMenu = useRef(null);
  const [popupIndex, setPopupIndex] = useState(0);

  const SelectTagRedux = useSelector(
    (updateCampaignTag) => updateCampaignTag.campaign_tag_filter
  ).value;
  const selectedStatusRedux = useSelector(
    (updateCampaignStatus) => updateCampaignStatus.campaign_status_filter
  ).value;
  const [campaignTileStatus, setTileStatusCampaign] = useState([]);

  const queryParams = new URLSearchParams(window.location.search);

  const selectedDeliveryStatusRedux = useSelector(
    (updateCampaignDeliveryStatus) =>
      updateCampaignDeliveryStatus.campaign_delivery_status_filter
  ).value;
  
  const memberOnlyStatusRedux = useSelector(
    (setMemberOnlyStatus) => setMemberOnlyStatus.campaign_member_only_filter
  ).value;

  const statusVal =queryParams.get("status") !==null ?`&status=${queryParams.get("status")}`:""
  const deliveryStatusVal =queryParams.get('deliveryStatus') && queryParams.get('deliveryStatus') !=="" && queryParams.get('deliveryStatus') !==null?
       `&deliveryStatus=${queryParams.get('deliveryStatus')}`:""
  let tagString = "";
  SelectTagRedux.map((tag) => {
    tagString += `&tag=${tag.value}`;
  });

  const colorCode = {
    cancelled: "alert-light-blue",
    closed: "alert-light-green",
    completed: "alert-light-floralw",
    in_progress: "alert-light-purple",
    created: "alert-light-sky",
  };
  const refButton1 = useRef(null);
  const refButton2 = useRef(null);
  const refButton3 = useRef(null);
  const refButton4 = useRef(null);
  const refButton5 = useRef(null);

  const [allCampaignStatus, updateCampaignStatusData] = useState([]);
  const [toggle, toggleFilter] = useState(false);
  const order = useSelector(
    (updateCampaignOrder) => updateCampaignOrder.campaign_count_display_order
  ).value;
  const dispatch = useDispatch();

  const toggleSetting = (event, index) => {
    if (event.code === "Enter") {
      if (event.target.children[1]?.className === "popover-body") {
        $(event.target).attr('aria-expanded', 'true');
        tilesMenu.current = event.target.children[0].children[3].id
        event.target.children[0].children[3].style.display = "block";
        event.target.children[1].style.display = "block";
        $(event.target.children[1]).find('input:first').trigger('focus');
      }
      toggleFilter(true);
    }
    if (event.type === "click") {
      const elem = $(document.activeElement);
      if (event.target.children[1]?.className === "popover-body") {
        elem.attr('aria-expanded', 'true');
        tilesMenu.current = event.target.children[0].children[3].id
        event.target.children[0].children[3].style.display = "block";
        event.target.children[1].style.display = "block";
        $(event.target.children[1]).find('input:first').trigger('focus');
      } else if (elem.length) {
        elem.find('.popover-body').css('display', 'none');
        elem.find('.triangle-with-shadow').css('display', 'none');
      }
      toggleFilter(true);
    }
    setPopupIndex(index)
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        refButton1.current?.children[1] &&
        !refButton1.current.contains(event.target)
      ) {
        refButton1.current.children[0].children[3].style.display = "none";
        refButton1.current.children[1].style.display = "none";
      }
      if (
        refButton2.current?.children[1] &&
        !refButton2.current.contains(event.target)
      ) {
        refButton2.current.children[0].children[3].style.display = "none";
        refButton2.current.children[1].style.display = "none";
      }
      if (
        refButton3.current?.children[1] &&
        !refButton3.current.contains(event.target)
      ) {
        refButton3.current.children[0].children[3].style.display = "none";
        refButton3.current.children[1].style.display = "none";
      }
      if (
        refButton4.current?.children[1] &&
        !refButton4.current.contains(event.target)
      ) {
        refButton4.current.children[0].children[3].style.display = "none";
        refButton4.current.children[1].style.display = "none";
      }
      if (
        refButton5.current?.children[1] &&
        !refButton5.current.contains(event.target)
      ) {
        refButton5.current.children[0].children[3].style.display = "none";
        refButton5.current.children[1].style.display = "none";
      }
    };
    const handleEscape = (event) => {
      if (event.key === Constants.ESCAPE && refButton1.current !== null && refButton1.current.contains(event.target)) {
        refButton1.current.children[0].children[3].style.display = "none";
        refButton1.current.children[1].style.display = "none";
      }
      if (event.key === Constants.ESCAPE && refButton2.current !== null && refButton2.current.contains(event.target)) {
        refButton2.current.children[0].children[3].style.display = "none";
        refButton2.current.children[1].style.display = "none";
      }
      if (event.key === Constants.ESCAPE && refButton3.current !== null && refButton3.current.contains(event.target)) {
        refButton3.current.children[0].children[3].style.display = "none";
        refButton3.current.children[1].style.display = "none";
      }
      if (event.key === Constants.ESCAPE && refButton4.current !== null && refButton4.current.contains(event.target)) {
        refButton4.current.children[0].children[3].style.display = "none";
        refButton4.current.children[1].style.display = "none";
      }
      if (event.key === Constants.ESCAPE && refButton5.current !== null && refButton5.current.contains(event.target)) {
        refButton5.current.children[0].children[3].style.display = "none";
        refButton5.current.children[1].style.display = "none";
      }
      if (event.key === Constants.ESCAPE && tilesMenu.current){
        $('#'+tilesMenu.current).closest('.selection-department').attr('aria-expanded', 'false');
        $('#'+tilesMenu.current).closest('.selection-department').trigger('focus');
        tilesMenu.current = '';
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    document.addEventListener("focus", handleClickOutside, true);
    document.addEventListener("keydown", handleEscape, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
      document.removeEventListener("focus", handleClickOutside, true);
      document.removeEventListener("keydown", handleEscape, true);
    };
  }, [refButton1, refButton2, refButton3, refButton4, refButton5]);

  // useEffect(()=>{
  //   setTimeout(() => {
  //     if(refButton1.current !== null){
  //       refButton1.current.children[0].children[3].style.display = "none";
  //     refButton1.current.children[1].style.display = "none";

  //     refButton2.current.children[0].children[3].style.display = "none";
  //     refButton2.current.children[1].style.display = "none";

  //     refButton3.current.children[0].children[3].style.display = "none";
  //     refButton3.current.children[1].style.display = "none";

  //     refButton4.current.children[0].children[3].style.display = "none";
  //     refButton4.current.children[1].style.display = "none";

  //     refButton5.current.children[0].children[3].style.display = "none";
  //     refButton5.current.children[1].style.display = "none";

  //     }
      
  //   }, 1500);

  // },[order]);

  const [campaignCountLoaded, hideCampaignStatusLoader] = useState(true);

  const campStatusFilterSelector = useSelector(
    (campaignCountFilter) => campaignCountFilter.campaign_status_display
  ).value;

  const campaignOwnerFilterRedux = useSelector(
    (campaignOwnerFilterStatus) => campaignOwnerFilterStatus.campaign_owner_filter
  ).value;

  const selectedPosition = campStatusFilterSelector[0]?.position;
  const selectedData = campStatusFilterSelector[1]?.data;
  const allStatus = [];

  useEffect(() => {
    // Get the current URL
    const currentURL = window.location.href;

    // Create a URL object to work with query parameters
    const url = new URL(currentURL);

    // Remove the specific query parameter
    url.searchParams.delete('countStatus');

    // Replace the current URL with the modified URL
    window.history.replaceState(null, '', url.href);
  }, []);

  useEffect(() => {
    getAxiosResponse(
      APIUrls.WORKSPACE_STATUS_COUNT +
        `?campaignOwner=${campaignOwnerFilterRedux}&onlyMember=${memberOnlyStatusRedux}`
    )
      .then((res) => {
        if (res.data.status === "success") {
          var keys = Object.keys(res.data.data);
          var values = Object.values(res.data.data);
          keys.map((key, index) => {
            allStatus.push({
              label: key.replaceAll("_", " "),
              count: values[index],
              code: key.toLowerCase(),
              shortLabel:translate(`campaign_page.${key.toLowerCase()}`),
              statusKey:key?.toLowerCase()
            });
          });
          updateCampaignStatusData(allStatus.sort((a,b)=>a.shortLabel.localeCompare(b.shortLabel)));
          setTileStatusCampaign(allStatus.sort((a,b)=>a.shortLabel.localeCompare(b.shortLabel)))
          hideCampaignStatusLoader(false);
        }
      })
    if (allCampaignStatus.length > 0) {
      const orignalPosition = allCampaignStatus.findIndex(
        (proStat) => proStat.code === selectedData
      );

      const newOrder = order.map((ord, index) => {
        if (index === selectedPosition) {
          return ord, orignalPosition;
        }
        return ord;
      });
      dispatch(updateCampaignOrder(newOrder));
  }
  }, [
  ]);
  const selectedOption = useSelector((projectCountFilter) => projectCountFilter.project_status_display).value;
  useEffect(() => {
     if(selectedOption && selectedOption?.length > 1 && selectedOption[1]?.data !==undefined){
      let currentSelectedData=allCampaignStatus.find(status => status.code === selectedOption[1].data?.toLowerCase())
      let data = campaignTileStatus.map((data,index) => index === popupIndex ? currentSelectedData : data)
      setTileStatusCampaign(data);
     }
  }, [selectedOption]);


  const handleStatusChange = (selectedStatus) => {
    dispatch(updateCampaignStatus(selectedStatus));
    setParamsToUrl('status',selectedStatus)
  };

  const setParamsToUrl=(key,status)=>{
    let value="";
      if(status==="Created"){
         value="CREATED"
      }else if(status==="Closed"){
         value="CLOSED"
      }else if(status==="Completed"){
         value="COMPLETED"
      }else if(status==="In Progress"){
        value="IN_PROGRESS";
      }else if(status==="Cancelled"){
        value="CANCELLED";
      }
    const currentURL = window.location.href;
// Create a URL object to parse and modify the URL
const url = new URL(currentURL);
// Remove query parameters by setting them to an empty string
url.search = '';
// Replace the current URL with the modified URL (without query parameters)
window.history.replaceState({}, document.title, url.toString());
const queryParams = new URLSearchParams(window.location.search);
    queryParams.set(key, value);
    queryParams.set('countStatus','change');
     navigate(`/campaigns?${queryParams.toString()}`);
      dispatch(updateCampaignStatus(value));
  }

  return  (
    <ul className="list-box-block flex" campaign-tour="box-tiles">
      {campaignTileStatus.map((data,index)=>(
        <li aria-label={data?.label}>
        <div
          className={"list-box " + Object.values(colorCode)[index]}
        >
          <div tabIndex="0" className="number-text" 
          onClick={()=>setParamsToUrl("status",translate(`campaign_page.${data?.code}`))}
          role="link">
            <strong>{data?.count ? data?.count : 0}</strong>
            <p>{data?.shortLabel}</p>
          </div>
          <div
            className="selection-department hover"
            role="button"
            aria-label="Select status menu"
            tabIndex="0"
            onClick={(e) => {
              toggleSetting(e,index);
            }}
            onKeyDown={(e) => {
              toggleSetting(e,index);
            }}
            ref={refButton1}
          >
            <div className="dots hover">
              <span></span>
              <span></span>
              <span></span>
              {popupIndex===index &&
              <div
                id={data?.count}
                className="triangle-with-shadow"
              ></div>}
            </div>
            {popupIndex===index &&
            <div className="popover-body" ref={refButton1}>
              <Popover
                uniqueId={0}
                key={data?.shortLabel}
                type={allCampaignStatus}
                defSelected={data?.code}
                dashboardTilesStatus={campaignTileStatus}
                index={popupIndex}
              />
            </div>}
          </div>
        </div>
      </li>
      ))}
    </ul>
  );
}
